/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingPlan } from './TrainingPlan';
import {
    TrainingPlanFromJSON,
    TrainingPlanFromJSONTyped,
    TrainingPlanToJSON,
    TrainingPlanToJSONTyped,
} from './TrainingPlan';

/**
 * 
 * @export
 * @interface UpdatePlanAndNotifyDTO
 */
export interface UpdatePlanAndNotifyDTO {
    /**
     * 
     * @type {TrainingPlan}
     * @memberof UpdatePlanAndNotifyDTO
     */
    plan: TrainingPlan;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlanAndNotifyDTO
     */
    notifyUsers: boolean;
}

/**
 * Check if a given object implements the UpdatePlanAndNotifyDTO interface.
 */
export function instanceOfUpdatePlanAndNotifyDTO(value: object): value is UpdatePlanAndNotifyDTO {
    if (!('plan' in value) || value['plan'] === undefined) return false;
    if (!('notifyUsers' in value) || value['notifyUsers'] === undefined) return false;
    return true;
}

export function UpdatePlanAndNotifyDTOFromJSON(json: any): UpdatePlanAndNotifyDTO {
    return UpdatePlanAndNotifyDTOFromJSONTyped(json, false);
}

export function UpdatePlanAndNotifyDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlanAndNotifyDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'plan': TrainingPlanFromJSON(json['plan']),
        'notifyUsers': json['notifyUsers'],
    };
}

export function UpdatePlanAndNotifyDTOToJSON(json: any): UpdatePlanAndNotifyDTO {
    return UpdatePlanAndNotifyDTOToJSONTyped(json, false);
}

export function UpdatePlanAndNotifyDTOToJSONTyped(value?: UpdatePlanAndNotifyDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan': TrainingPlanToJSON(value['plan']),
        'notifyUsers': value['notifyUsers'],
    };
}

